// Converts a normal YouTube watch/share link into an embeddable URL.
// Handles: youtube.com/watch?v=ID, youtu.be/ID, already-embed URLs, and unlisted links with extra params.
export function toYouTubeEmbed(url) {
  if (!url) return "";
  try {
    const u = new URL(url.trim());
    if (u.hostname.includes("youtu.be")) {
      const id = u.pathname.replace("/", "");
      return `https://www.youtube.com/embed/${id}`;
    }
    if (u.pathname.startsWith("/embed/")) {
      return url;
    }
    const id = u.searchParams.get("v");
    if (id) return `https://www.youtube.com/embed/${id}`;
    return url;
  } catch (e) {
    return url;
  }
}
